function o(a) {
  return Object.keys(a).reduce((r, n) => {
    const e = a[n];
    return typeof e < "u" && (e instanceof Array ? e : [e]).forEach((c) => r.append(n, c.toString())), r;
  }, new URLSearchParams());
}
function s(a) {
  return [...new URLSearchParams(a).entries()].reduce(
    (r, [n, e]) => {
      const t = r[n];
      return {
        ...r,
        [n]: (
          // Do an explicit undefined check because the value might be an empty
          // string and we want to preserve that.
          typeof t < "u" ? t instanceof Array ? [...t, e] : [t, e] : e
        )
      };
    },
    {}
  );
}
export {
  o as searchParamsToURLSearchParams,
  s as searchStringToParams
};
//# sourceMappingURL=index.js.map
